import React from "react";
import PendingComment from "../PendingComment/PendingComment";
import PropTypes from "prop-types";
import { CommentPropType, ItemPropType } from "../../PropTypes";

function PendingCommentList(props) {
  let sortedComments = [...props.comments];
  sortedComments.sort(
    (a, b) => new Date(b.lastEdited) - new Date(a.lastEdited)
  );
  if (props.comments) {
    return (
      <div className="ugc-pending-comments-list">
        <h2 className="sr-only">Pending Comments</h2>
        <div>
          {sortedComments.map((comment) => (
            <PendingComment
              key={comment.id}
              externalId={props.externalId}
              comment={comment}
              item={props.item}
            />
          ))}
        </div>
      </div>
    );
  } else return <></>;
}

PendingCommentList.propTypes = {
  skip: PropTypes.number,
  top: PropTypes.number,
  setSkip: PropTypes.func,
  externalId: PropTypes.string,
  comments: PropTypes.arrayOf(CommentPropType),
  item: ItemPropType
};

export default PendingCommentList;
